import React, { Component } from 'react';
import { Big3Common } from '../../../js/IncludeManager'
import { GoodsPhoto } from "../../../js/ComponentManager";

/* 개발담당:양유빈
 * 화면기능:재고확인
 * 세부설명:
*/

export class StockQstCon extends Component {
    static displayName = StockQstCon.name;

    constructor(props) {
        super(props);
        this.state = {
            MasterData:[],
            GoodsList:[],
        };

        this.CsName = Big3Common.ContentState;
        this.QstStatus=Big3Common.Util.GetContentState(this.props.ContentState,this.CsName.QstStatus,"");
        this.QstgrpNo=Big3Common.Util.GetContentState(this.props.ContentState,this.CsName.QstgrpNo,"");
        this.Union_Uid=Big3Common.Util.GetContentState(this.props.ContentState,this.CsName.Union_Uid,"");
    }
    //초기화
    async componentDidMount() {
         await this.CallQstMgtlGoodsListData();
    }
    //주문문의 조회(마스터+상태+코멘트 내역)
    async CallQstMgtlGoodsListData() {
        try {
            Big3Common.Util.LoadingOn();
            let Model = {
                Qstgrp_No:this.QstgrpNo,
                Union_Uid: this.Union_Uid,
                Qst_Status:this.QstStatus
            }
            let Data = await Big3Common.Post('api/Order/QuestionMgr/GetQstMgtlGoodsList',Model,true);
            if (Data.codeName === Big3Common.ResultCode.Success) {
                const CallList = JSON.parse(Data.multiDataTable);
                this.setState({
                    MasterData: CallList.Master,
                    GoodsList: CallList.GoodsList
                });
            }
            else {
                console.log(Data.message);
            }
        }
        catch (e) {
            console.log("CallQstMgtlGoodsListData: ", e)
        }
        finally {
            Big3Common.Util.LoadingOff();
        }
        return false;
    }
    //헤더
    Masterrender()
    {   
        if(this.state.MasterData.length===0) return false;
        const MasterData = this.state.MasterData[0];
        return(
            <div className="order_shop_info_box stock_info">
                {MasterData.ordgrp_no === 0 ? <div className="Question_number">문의번호 : {MasterData.qstgrp_no}</div> : <div className="Question_number">문의번호 : {MasterData.qstgrp_no}(주문번호: {MasterData.ordgrp_no})</div>}          
                <div className="Question_number">문의날짜 : {MasterData.reg_dt}</div>
             </div>
        )
    }
    GoodsSubrender(GoodsList) {
        return (
            <React.Fragment>
                <div className="table_box">
                    <table className="table">
                        <colgroup>
                            <col width="44%" />
                            <col width="12%" />
                            <col width="44%" />
                        </colgroup>
                        <tbody>
                            {
                                GoodsList.map((subList, sdx) =>
                                    <tr key={sdx}>
                                        <td> {subList.crd_cd_nm}  /  {subList.size_nm}  ({Big3Common.Util.Money(subList.goods_price)})</td>
                                        <td>{Big3Common.Util.Money(subList.quan)}</td>
                                        <td>{Big3Common.Util.Money(subList.goods_price_tot)}원</td>
                                    </tr>
                                )
                            }
                        </tbody>
                        <tfoot>
                            <tr>
                                <td>합계</td>
                                <td>{GoodsList.reduce((acc, item) => acc + item.quan, 0)}</td>
                                <td>{Big3Common.Util.Money(GoodsList.reduce((acc, item) => acc + item.goods_price_tot, 0))}원</td>
                            </tr>
                        </tfoot>
                    </table>
                </div>
            </React.Fragment>
        )
    }
    Goodsrender() {
        if (this.state.GoodsList === 0) return false;
        const GoodsListTemp = this.state.GoodsList;
        const GoodsListGroup = Big3Common.Util.groupBy(GoodsListTemp, list => list.goods_no);
        const GoodsListJson = [];
        for (const item of GoodsListGroup.entries()) {
            GoodsListJson.push({
                "GoodsNo": item[0],
                "GoodsList": item[1],
            });
        }
        return (
            <>
                {
                    GoodsListJson.map((list, idx) =>
                        <div className="order_dtl_box" key={idx}>
                            <div className="order_goods_info">
                                <div className="order_goods_img">
                                    <GoodsPhoto
                                        className="order_goods_img_in"
                                        ImageSrc={list.GoodsList[0].img_220}
                                    />
                                </div>
                                <div className="order_txt">
                                    <div className="goods_title">{list.GoodsList[0].goods_nm}</div>
                                    <div className="goods_price">{Big3Common.Util.Money(list.GoodsList[0].goods_price)}원</div>
                                </div>
                            </div>
                            {this.GoodsSubrender(list.GoodsList)}
                        </div>
                    )
                }
                <div className="table_box sum_table">
                    <React.Fragment>
                        <table className="table">
                            <colgroup>
                                <col width="44%" />
                                <col width="12%" />
                                <col width="44%" />
                            </colgroup>
                            <tbody>
                                <tr>
                                    <td>총 합계</td>
                                    <td>{GoodsListTemp.reduce((acc, item) => acc + item.quan, 0)}</td>
                                    <td>{Big3Common.Util.Money(GoodsListTemp.reduce((acc, item) => acc + item.goods_price_tot, 0))}원</td>
                                </tr>
                            </tbody>
                        </table>
                    </React.Fragment>
                </div>
            </>
        )
    }
    render() {
        const Masterrender=this.Masterrender();
        const Goodsrender=this.Goodsrender();
        return (
              <div className="container_box d_padding p_margin ">
                {Masterrender}
                {Goodsrender}
              </div>
        );
    }
}
